<template>
  <Wrapper
    v-show="
      !preview && renderTools &&
      !['reheight_widget', 'remargin_widget', 'sort_widget', 'reheight_grid', 'remargin_grid', 'reheight_component'].includes(mode) &&
      widgetHover.id &&
      widgetHover.id != widgetActive.id
    "
    @mouseleave="leave"
    @click="click"
    :position="widgetHoverPosition"
    id="widget-hover-frame"
    :class="{'top': !isOverScroll, 'bottom': isOverScroll, 'pointer-none': widgetType == 'Table'}"
  >
    <WidgetHover 
      :style="{'left': leftPosition}" 
      :class="{'header-widget': isHeaderWidget,'lbl-name':isHeaderWidgetOnTopBar,'label-name-frame':!isHeaderWidgetOnTopBar }"
    >
      {{ widgetType }}
    </WidgetHover>
  </Wrapper>
</template>

<script>
import { WidgetHover, Wrapper } from "./WidgetHover.styled";
import { WIDGET } from "@model/components/componentMeta.model";

import { mapGetters } from "vuex";

export default {
  components: {
    WidgetHover,
    Wrapper,
  },
  data() {
    return {
      positionTool: "top",
      topElementPosition: 0,
    }
  },
  methods: {
    leave() {
      this.$store.dispatch("designIframe/frame/setWidgetHover", {});
      this.$store.dispatch("designIframe/frame/setSiteWidgetHover", {});
    },
    click() {
      if (this.component.id.includes("HEADER") || this.component.id.includes("FOOTER")) {
        this.$store.dispatch("designIframe/frame/setCellHover", {});
        this.$store.dispatch("designIframe/frame/setCellActive", {});
        this.$store.dispatch("designIframe/frame/setSectionHover", {});
        this.$store.dispatch("designIframe/frame/setSectionActive", {});
        this.$store.dispatch("designIframe/frame/setSlideSectionHover", {});
        this.$store.dispatch("designIframe/frame/setSlideSectionActive", {});
        this.$store.dispatch("designIframe/frame/setSlideContainerActive", {});
        this.$store.dispatch("designIframe/frame/setSlideBlockHover", {});
        this.$store.dispatch("designIframe/frame/setSlideBlockActive", {});
        this.$store.dispatch("designIframe/frame/setSiteWidgetActive", {
          component_id: this.component.id,
        });
        this.$store.dispatch("designIframe/frame/setFloatFrameActive", {
          component_id: this.component.id.includes("HEADER") ? 'comp-HEADER' : 'comp-FOOTER',
          name: this.component.id.includes("HEADER") ? 'Header' : 'Footer',
        });
      } 
      else if (this.parent_widget_id.includes("slc")) { // Slide Container
        const slide_page_id = this.grid_id;
        this.$store.dispatch("designIframe/frame/setCellHover", {});
        this.$store.dispatch("designIframe/frame/setCellActive", {});
        this.$store.dispatch("designIframe/frame/setSectionHover", {});
        this.$store.dispatch("designIframe/frame/setSectionActive", {});
        this.$store.dispatch("designIframe/frame/setSlideSectionHover", {});
        this.$store.dispatch("designIframe/frame/setSlideSectionActive", {});
        this.$store.dispatch("designIframe/frame/setSlideBlockHover", {});
        this.$store.dispatch("designIframe/frame/setSlideBlockActive", {});
        this.$store.dispatch("designIframe/frame/setFloatFrameActive", {});
        if (this.component.type == "SECTION_WIDGET_TEXT") {
          //
        }else{
          this.$store.dispatch("designIframe/component/elActive", {
            elementID: ["component", this.component.id],
          });
        }
        this.$store.dispatch("designIframe/frame/setSlideContainerActive", {
          component_id: this.parent_widget_id,
        });
        const indexSlidePage = this.components[this.section_id].componentsID.indexOf(slide_page_id)

        this.$store.dispatch("designIframe/frame/setSlideWidgetActive", {
          component_id: this.component.id,
          slide_section_id: this.section_id,
          index: indexSlidePage,
        });
        this.$store.dispatch("designIframe/frame/setParentWidgetActive", {
          component_id: this.component.id
        });
      }
      else if (this.parent_widget_id.includes("wdg")){
        this.$store.dispatch("designIframe/frame/setCellHover", {});
        this.$store.dispatch("designIframe/frame/setCellActive", {});
        this.$store.dispatch("designIframe/frame/setSectionHover", {});
        this.$store.dispatch("designIframe/frame/setSectionActive", {});
        this.$store.dispatch("designIframe/frame/setSlideSectionHover", {});
        this.$store.dispatch("designIframe/frame/setSlideSectionActive", {});
        this.$store.dispatch("designIframe/frame/setSlideContainerActive", {});
        this.$store.dispatch("designIframe/frame/setSlideBlockHover", {});
        this.$store.dispatch("designIframe/frame/setSlideBlockActive", {});
        if (this.component.type == "SECTION_WIDGET_TEXT") {
          //
        }else{
          this.$store.dispatch("designIframe/component/elActive", {
            elementID: ["component", this.component.id],
          });
        }
        this.$store.dispatch("designIframe/frame/setParentWidgetActive", {
          parent_id: this.parent_widget_id,
          component_id: this.component.id,
        });
      } else {
        this.$store.dispatch("designIframe/frame/setWidgetActive", {
          grid_id: this.grid_id,
          cell_id: this.cell_id,
          component_id: this.component.id,
        });
        this.$store.dispatch("designIframe/frame/setFloatFrameActive", {});
        this.$store.dispatch("designIframe/frame/setFloatFrameHover", {});
        this.$store.dispatch("designIframe/frame/setSectionHover", {});
        this.$store.dispatch("designIframe/frame/setSectionActive", {});
        this.$store.dispatch("designIframe/frame/setSlideSectionHover", {});
        this.$store.dispatch("designIframe/frame/setSlideSectionActive", {});
        this.$store.dispatch("designIframe/frame/setSlideContainerActive", {});
        this.$store.dispatch("designIframe/frame/setParentWidgetActive", {
          component_id: this.component.id
        });
      }

      if (this.component.type == WIDGET.prefixType + "TEXT_") {
        //
      } else if (this.component.type == WIDGET.prefixType + "SLIDE") { // Set Active Slide Widget and Inactive Slide Block
        this.$store.dispatch("designIframe/frame/setSlideBlockHover", {parent_id: this.component.id});
        this.$store.dispatch("designIframe/frame/setSlideBlockActive", {parent_id: this.component.id});
        this.$store.dispatch("designIframe/component/elActive", {
            elementID: ["component", this.component.id],
        });
      } else if (this.component.type.includes('HEADER_WIDGET')) { // Set Active Header Widget
        let toolID
        switch (this.component.type) {
          case "HEADER_WIDGET_MENU":
            toolID = "header_menu";
            break;
          case "HEADER_WIDGET_LOGO":
            toolID = "logo";
            break;
          case "HEADER_WIDGET_MEMBER":
            toolID = "member";
            break;
          case "HEADER_WIDGET_SOCIAL":
            toolID = "social";
            break;
          case "HEADER_WIDGET_LANGUAGE":
            toolID = "language";
            break;
          case "HEADER_WIDGET_CURRENCY":
            toolID = "currency";
            break;
          case "HEADER_WIDGET_SEARCH":
            toolID = "search";
            break;
          case "HEADER_WIDGET_TEXT":
            toolID = "text";
            break;
          case "HEADER_WIDGET_TOPMENU":
            toolID = "top_menu";
            break;
          case "HEADER_WIDGET_CART":
            toolID = "cart";
            break;
          case "HEADER_WIDGET_QUOTATION":
            toolID = "quotation";
            break;
          default:
            toolID = undefined;
            break;
        }
        this.$store.dispatch("designIframe/component/elActive", {
            elementID: ["header", 'design', toolID],
        });
        

      } else if (this.component.type.includes('FOOTER_WIDGET')){  // Set Active Footer Widget
         let toolID
        switch (this.component.type) {
        case "FOOTER_WIDGET_MENU":
          toolID = "footer_menu";
          break;
        case "FOOTER_WIDGET_LOGO":
          toolID = "logo";
          break;
        case "FOOTER_WIDGET_SUBSCRIBE":
          toolID = "subscribe";
          break;
        case "FOOTER_WIDGET_SOCIAL":
          toolID = "social";
          break;
        case "FOOTER_WIDGET_PARTNER":
          toolID = "partner";
          break;
        case "FOOTER_WIDGET_COPYRIGHT":
          toolID = "copyright";
          break;
        case "FOOTER_WIDGET_STATCOUNTER":
          toolID = "statcounter";
          break;
        case "FOOTER_WIDGET_TEXT1":
          toolID = "text";
          break;
        case "FOOTER_WIDGET_TEXT2":
          toolID = "text";
          break;
        case "FOOTER_WIDGET_TEXT3":
          toolID = "text";
          break;
        case "FOOTER_WIDGET_TEXT4":
          toolID = "text";
          break;
        case "FOOTER_WIDGET_FBLIKEBOX":
          toolID = "fblikebox";
          break;
        case "FOOTER_WIDGET_PAYMENT":
          toolID = "payment";
          break;
        case "FOOTER_WIDGET_SHIPPING":
          toolID = "shipping";
          break;
        case "FOOTER_WIDGET_TAGS":
          toolID = "tags";
          break;
        default:
          toolID = undefined;
          break;
        }
        this.$store.dispatch("designIframe/component/elActive", {
            elementID: ["footer", 'design', toolID],
        });
        if(toolID === 'fblikebox'){
          this.$store.dispatch("design/setModal", {
          name: "modal-fb-like-box",
        });
        }
      } else {
        this.$store.dispatch("designIframe/component/elActive", {
          elementID: ["component", this.component.id],
        });
      }
    },
  },
  computed: {
    ...mapGetters({
      sectionActive: "designIframe/frame/sectionActive",
      gridActive: "designIframe/frame/gridActive",
      cellActive: "designIframe/frame/cellActive",
      widgetHover: "designIframe/frame/widgetHover",
      widgetActive: "designIframe/frame/widgetActive",
      preview: "designIframe/preview",
      components: "designIframe/metadata/components",
      siteComponents: "designIframe/metadata/siteComponents",
      mode: "designIframe/mode",
      scrollPosition: "scrollPosition",
      renderTools: "designIframe/frame/renderTools",
      detectDevice: "detectDevice",
      languageEngine: "designIframe/userPreference/languageEngine"
    }),
    component() {
      if (this.widgetHover.id && (this.widgetHover.id.includes('HEADER') || this.widgetHover.id && this.widgetHover.id.includes('FOOTER'))) {
        return this.siteComponents[this.widgetHover.id];
      } else{
        return this.components[this.widgetHover.id];
      }
    },
    isHeaderWidget() {
      return this.component && this.component.type.includes("HEADER_WIDGET") ? true : false
    },
    isFooterWidget() {
      return this.component && this.component.type.includes("FOOTER_WIDGET") ? true : false
    },
    isHeaderWidgetOnTopBar() {
      if (this.isHeaderWidget) {
        let el = document.getElementById('comp-' + this.widgetHover.id)
        let elTop = document.getElementById('top-mb');
        if (el && el.classList.contains('on-topbar') || (!elTop && this.widgetHover.id.includes('HEADER'))) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
    indexOfButtonInButtonGroup() {
      if (!this.component || !this.widgetHover || !this.components) return '';
      let hover_have_parent = this.components && this.widgetHover && this.components[this.parent_widget_id];
      if (hover_have_parent && hover_have_parent.type === 'SECTION_WIDGET_BUTTON_GROUP') {
        return ' ' + (hover_have_parent.componentsID.indexOf(this.widgetHover.id) + 1);
      }
      return '';
    },
    widgetType() {
      if(!this.component) return "";
      let type = "";
      switch (this.component.type) {
        case "SECTION_WIDGET_BUTTON":
          type = "Button" + (this.indexOfButtonInButtonGroup);
          break;
        case "SECTION_WIDGET_LINE_SEPARATE":
          type = "Line";
          break;
        case "SECTION_WIDGET_CONTENT":
          type = "Blog";
          break;
        case "HEADER_WIDGET_MENU":
          type = "Header Menu";
          break;
        case "HEADER_WIDGET_LOGO":
          type = "Logo";
          break;
        case "HEADER_WIDGET_MEMBER":
          type = "Member";
          break;
        case "HEADER_WIDGET_SOCIAL":
          type = "Social";
          break;
        case "HEADER_WIDGET_LANGUAGE":
          type = "Language";
          break;
        case "HEADER_WIDGET_CURRENCY":
          type = "Currency";
          break;
        case "HEADER_WIDGET_SEARCH":
          type = "Search";
          break;
        case "HEADER_WIDGET_TEXT":
          type = "Text";
          break;
        case "HEADER_WIDGET_TOPMENU":
          type = "Top Menu";
          break;
        case "HEADER_WIDGET_CART":
          type = "Cart";
          break;
        case "HEADER_WIDGET_QUOTATION":
          type = "quote";
          break;
        case "FOOTER_WIDGET_MENU":
          type = "Footer Menu";
          break;
        case "FOOTER_WIDGET_LOGO":
          type = "Logo";
          break;
        case "FOOTER_WIDGET_SUBSCRIBE":
          type = "Subscribe";
          break;
        case "FOOTER_WIDGET_SOCIAL":
          type = "Social";
          break;
        case "FOOTER_WIDGET_PARTNER":
          type = "Logo Partner";
          break;
        case "FOOTER_WIDGET_COPYRIGHT":
          type = "Copyright";
          break;
        case "FOOTER_WIDGET_STATCOUNTER":
          type = "Stat Counter";
          break;
        case "FOOTER_WIDGET_TEXT1":
          type = "Text";
          break;
        case "FOOTER_WIDGET_TEXT2":
          type = "Text";
          break;
        case "FOOTER_WIDGET_TEXT3":
          type = "Text";
          break;
        case "FOOTER_WIDGET_TEXT4":
          type = "Text";
          break;
        case "FOOTER_WIDGET_FBLIKEBOX":
          type = "Facebook LikeBox";
          break;
        case "FOOTER_WIDGET_PAYMENT":
          type = "Payment";
          break;
        case "FOOTER_WIDGET_SHIPPING":
          type = "Shipping";
          break;
        case "FOOTER_WIDGET_TAGS":
          type = "Tage";
          break;
        default:
          type = this.component.type.replace(WIDGET.prefixType, "")
          break;
      }
      type = this.$helper.text.capitalize(type);
      return this.$te(`engine.floatframeTool.floatframeHover.lbl${type}`, this.languageEngine) ? this.$t(`engine.floatframeTool.floatframeHover.lbl${type}`, this.languageEngine) : type;
    },
    isOverScroll() {
      this.scrollPosition;
      const diff = this.scrollPosition - this.topElementPosition;
      if (diff >= 0 || this.isHeaderWidgetOnTopBar) {
        return true;
      } else {
        return false;
      }
    },
    grid_id() {
      return this.cell_id && !this.isHeaderWidget && !this.isFooterWidget && Object.entries(this.components).filter(
        (item) =>
          item[1].componentsID &&
          item[1].componentsID.includes(this.cell_id)
      )[0][0];
    },
    cell_id() {
      return this.component && !this.isHeaderWidget && !this.isFooterWidget && Object.entries(this.components).filter(
        (item) =>
          item[1].componentsID &&
          item[1].componentsID.includes(this.component.id)
      )[0][0];
    },
    parent_widget_id(){
      return this.component && !this.isHeaderWidget && !this.isFooterWidget && Object.entries(this.components).filter(
      (item) =>
        item[1].componentsID  &&
        item[1].componentsID.includes(this.component.id) ||
        item[1].componentsIDHover  &&
        item[1].componentsIDHover.includes(this.component.id)
      )[0][0];
    },
    cellComponent() {
      return this.cell_id && this.components[this.cell_id] 
    },
    cellWidth() {
      if (!this.cell_id) return 0;
      let id = "comp-" + this.cell_id;
      const target = document.getElementById(id);

      let rect = target.getBoundingClientRect();
      let width = rect.width;
      let cellPaddingLeft =
        this.components[this.cell_id].style.paddingLeft;
      let cellPaddingRight =
        this.components[this.cell_id].style.paddingRight;

      width = width - (cellPaddingLeft + cellPaddingRight);

      return width
    },
    indexCell() {
      if (this.components[this.grid_id]) {
        if (this.detectDevice == 'mobile') {
          return this.components[this.grid_id].componentsIDMobile.indexOf(this.cell_id);
        } else {
          return this.components[this.grid_id].componentsID.indexOf(this.cell_id);
        }
      } else {
        return 0;
      }
    },
    indexWidget() {
      return this.cellComponent.componentsID.indexOf(this.widgetHover.id);
    },
    isFirstIndex() {
      return this.indexWidget == 0;
    },
    widgetWidth() {
      if (!this.component) return 0;
      let id = "comp-" + this.component.id;
      const target = document.getElementById(id);

      let rect = target.getBoundingClientRect();
      let width = rect.width;

      return width
    },
    isWidgetOverlap() {
      return this.component && !this.isHeaderWidget && !this.isFooterWidget && this.widgetWidth >= this.cellWidth && this.cellComponent.style.paddingTop == 0 && this.cellComponent.style.paddingLeft == 0 && this.isFirstIndex
    },
    section_id() {
      return this.grid_id && Object.entries(this.components).filter(
        (item) =>
          item[1].componentsID &&
          item[1].componentsID.includes(this.grid_id)
      )[0][0];
    },
    sectionComponent() {
      return this.section_id && this.components[this.section_id]
    },
    gridMarginTop() {
      return (
        this.components[this.grid_id] &&
        this.components[this.grid_id].style.marginTop
      );
    },
    indexGrid() {
      return this.sectionComponent.componentsID.indexOf(this.grid_id);
    },
    isFirstCellIndex() {
      return this.indexGrid == 0;
    },
    isSectionOverlap() {
      return this.sectionComponent && this.sectionComponent.style.width == 'container-fluid' && this.isFirstCellIndex && this.gridMarginTop == 0
    },
    isParentButtonGroup() {
      const active = this.components && this.widgetActive && this.components[this.widgetActive.id];
      const hover = this.components && this.widgetHover && this.components[this.widgetHover.id];
      if (active && active.type === 'SECTION_WIDGET_BUTTON') {
        if (
          hover &&
          hover.type === 'SECTION_WIDGET_BUTTON_GROUP' &&
          Array.isArray(hover.componentsID) &&
          hover.componentsID.indexOf(this.widgetActive.id) === 0
        ) {
          return true;
        }
      }
      return false;
    },
    isParentButton(){
      const active = this.components && this.widgetActive && this.components[this.widgetActive.id];
      const hover = this.components && this.widgetHover && this.components[this.widgetHover.id];
      if (active && active.type === 'SECTION_WIDGET_BUTTON_GROUP') {
        if (
          hover &&
          hover.type === 'SECTION_WIDGET_BUTTON' &&
          Array.isArray(active.componentsID) &&
          active.componentsID.indexOf(this.widgetHover.id) === 0
        ) {
          return true;
        }
      }
      return false;
    },
    topPositionBtnGrpFixActive() {
      let hi = this.components[this.widgetActive.id].type == 'SECTION_WIDGET_BUTTON_GROUP' && this.components[this.widgetActive.id].style.paddingY ? this.components[this.widgetActive.id].style.paddingY : 0
      return hi;
    },
    topPositionBtnFixActive() {
      const active = this.components && this.widgetActive && this.components[this.widgetActive.id];
      const hover = this.components && this.widgetHover && this.components[this.widgetHover.id];
      if (active && active.type === 'SECTION_WIDGET_BUTTON' && hover && hover.type === 'SECTION_WIDGET_BUTTON_GROUP') {
        let hi =  hover.style.paddingY ? hover.style.paddingY : 0
        return hi;
      }
      return 0;
    },
    leftPosition() {
      let position = 0;
      if (this.widgetHover.id && (this.isHeaderWidge || this.isFooterWidget || this.parent_widget_id && this.parent_widget_id.includes("wdg")))  {
          if(this.isParentButton){
            if(this.topPositionBtnGrpFixActive >= 16){
              return '0px';
            }else{
              return '105px';
            }
          }else{
           return '0px';
          }
      } else {
        if (this.sectionActive.id && this.sectionActive.id == this.section_id) { // Active this Section
          if (this.gridActive.id && this.gridActive.id == this.grid_id) { // Active this Grid
            if (this.cellActive.id && this.cellActive.id == this.cell_id && this.isSectionOverlap && this.isWidgetOverlap) { // Active this Cell and Section [isSectionOverlap === true]
              if (this.indexCell == 0) { // First Cell
                position = 178;
              } else { // Not First Cell
                position = 54;
              }
            } else if (this.cellActive.id && this.cellActive.id != this.cell_id && this.isSectionOverlap && this.isWidgetOverlap) { // Active this grid but not this cell [isSectionOverlap === true]
              if (this.indexCell == 0) { // First Cell
                position = 126;
              }
            }
          }
        } else if (this.gridActive.id && this.gridActive.id == this.grid_id) { // Active this Grid
          if (this.cellActive.id != this.cell_id && this.isWidgetOverlap) {  // Active this Cell [isWidgetOverlap === true]
            if (this.indexCell == 0) { // First Cell {Grid Widget}
              position = 56;
            }
          }
        }else{ //btn not ativ grip or cell
          if(this.isParentButtonGroup){
            if(this.topPositionBtnFixActive >= 16){
              position = 0;
            }else{
              position = 75;
            }
          }else{
            position = 0;
          }
        }
        return `${position}px`;
      }
    },
    widgetHoverPosition() {
      if (this.widgetHover.id == 'HEADER_WIDGET_MENU' && this.siteComponents.HEADER.style.layout == '05') {
        // Header widget menu ใน Header layout 05 จะแบ่งออกเป็น 3 ก้อนอยู่แยกกัน เลยต้องคำนวน position floatframe ใหม่
        let menuRow1 = document.getElementsByClassName('hmenu-row-1')[0]
        let menuRow2 = document.getElementsByClassName('hmenu-row-2')[0]
        let compHeaderMenu = document.getElementById('comp-HEADER_WIDGET_MENU')
        let menuRow2PosBottom = menuRow2 ? menuRow2.getBoundingClientRect().bottom : 0
        let menuRow1PosLeft = menuRow1 ? menuRow1.getBoundingClientRect().left : 0
        let menuRow1Width = menuRow1 ? menuRow1.offsetWidth : 0
        let menuRow2Width = menuRow2 ? menuRow2.offsetWidth : 0
        let headerMenuPosTop = compHeaderMenu ? compHeaderMenu.getBoundingClientRect().top : 0
        return {
          width: Math.max(menuRow1Width, menuRow2Width) + 'px',
          height: menuRow2PosBottom > 0 ? (menuRow2PosBottom - headerMenuPosTop) + 'px' : this.widgetHover.position.height,
          top: this.widgetHover.position.top,
          left: menuRow1PosLeft + 'px'
        };
      } else {
        return this.widgetHover.position
      }
    },
  },
  watch: {
    widgetHover: {
      deep: true,
      handler() {
        const element = document.getElementById("widget-hover-frame")
        if(element) {
          this.$nextTick(() => {
            this.topElementPosition = element.offsetTop;
          })
        }
      }
    }
  },
};
</script>

<style>
</style>